import { useMemo } from 'react';

import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  LoginFormType,
  Field,
  Form,
  Submit,
  FormErrors,
  getSchema,
} from '../../forms/loginFormForm';

export interface LoginFormProps {
  onSubmit: (values: LoginFormType) => void;
  loading?: boolean;
  formError?: FormErrors;
}

export const LoginForm = ({ loading, formError, onSubmit }: LoginFormProps) => {
  const { t } = useTranslation();
  const scheme = useMemo(() => getSchema(t), [t]);

  return (
    <Form
      initialErrors={{ ...formError }}
      initialValues={{ rememberMe: true }}
      validationSchema={scheme}
      onSubmit={onSubmit}
    >
      <Stack spacing={24}>
        <Field.Text
          allowSubmit
          helperTextAbsolute
          label={t('auth.login.emailLabel')}
          name="email"
          placeholder={t('auth.login.emailPlaceholder')}
          showCopyButton={false}
          type="email"
        />
        <Field.Password
          allowSubmit
          helperTextAbsolute
          label={t('auth.login.passwordLabel')}
          name="password"
          placeholder={t('auth.login.passwordPlaceholder')}
        />
      </Stack>
      <Submit
        fullWidth
        label={t('auth.login.submitButton')}
        loading={loading}
      />
    </Form>
  );
};
